import { render, staticRenderFns } from "./AddBlackList.vue?vue&type=template&id=0e094756&scoped=true&"
import script from "./AddBlackList.vue?vue&type=script&lang=js&"
export * from "./AddBlackList.vue?vue&type=script&lang=js&"
import style0 from "./AddBlackList.vue?vue&type=style&index=0&id=0e094756&scoped=true&lang=css&"
import style1 from "./AddBlackList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e094756",
  null
  
)

export default component.exports